import { render, staticRenderFns } from "./general-information.vue?vue&type=template&id=71b72221&"
import script from "./general-information.vue?vue&type=script&lang=js&"
export * from "./general-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports